import React from 'react';
import { EmailBlock, ImageBlockContent } from '../types';
import { Image as ImageIcon } from 'lucide-react';

interface ImageBlockProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

export const ImageBlock: React.FC<ImageBlockProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const content = block.content as ImageBlockContent;

  const style: React.CSSProperties = {
    textAlign: content.align || 'center',
    padding: '10px',
    ...block.styles
  };

  const imgStyle: React.CSSProperties = {
    width: content.width || '100%',
    height: content.height || 'auto',
    borderRadius: content.borderRadius || '0',
    maxWidth: '100%',
    display: 'block',
    margin: '0 auto'
  };

  const imageElement = content.src ? (
    <img
      src={content.src}
      alt={content.alt || ''}
      style={imgStyle}
      onError={(e) => {
        // Show placeholder on error
        e.currentTarget.style.display = 'none';
      }}
    />
  ) : (
    <div className={`
      flex flex-col items-center justify-center p-8 border-2 border-dashed rounded
      ${isDarkMode ? 'border-gray-600 bg-gray-700' : 'border-gray-300 bg-gray-50'}
    `}>
      <ImageIcon className={`
        w-12 h-12 mb-2
        ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}
      `} />
      <p className={`
        text-sm
        ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}
      `}>
        No image selected
      </p>
    </div>
  );

  const wrapper = content.link ? (
    <a href={content.link} target="_blank" rel="noopener noreferrer">
      {imageElement}
    </a>
  ) : imageElement;

  return (
    <div style={style}>
      {wrapper}
    </div>
  );
};
